import {AppRoutes} from "../utils/constants";
import {getSearchFilter} from "../modules/auth-persistor";

const HelperService = {
  getDayjs: function () {
    if (window.globalDayjs){
      return window.globalDayjs;
    }
    const dayjs = require('dayjs');
    const customParseFormat = require('dayjs/plugin/customParseFormat');
    const timezone = require('dayjs/plugin/timezone');
    const utc = require('dayjs/plugin/utc');
    const isToday = require('dayjs/plugin/isToday');
    const isTomorrow = require('dayjs/plugin/isTomorrow');
    const isYesterday = require('dayjs/plugin/isYesterday');
    dayjs.extend(customParseFormat);
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(isYesterday);
    dayjs.extend(isToday);
    dayjs.extend(isTomorrow);
    window.globalDayjs = dayjs;
    return dayjs;
  },
  getRandomAnimation: function (){
    const animations = [
      'fade',
      'fade-right',
      // 'zoom-in',
      // 'slide-right',
      // 'flip-right', // too crazy + screws layout
      // 'flip-left',
      // 'slide-left',
      // 'fade-left',
    ];
    return animations[Math.floor(Math.random() * animations.length)];
  },
  handleFormErrors: function (error, validationErrorsSetter){
    if( error.response?.data?.errors?.length && error.response?.status===400 && validationErrorsSetter ){
      let err = {};
      for (const field in error.response.data.errors){
        if (!err[error.response.data.errors[field].name]){
          err[error.response.data.errors[field].name] = [];
        }
        err[error.response.data.errors[field].name] = [...err[error.response.data.errors[field].name], error.response.data.errors[field].error];
      }
      validationErrorsSetter(err);
    }
  },
  handleApiErrors: function (error, onErrorCallback=null, defaultMessage="The server encountered an error and could not complete your request.<br /><br />Please reload the page or try again later.<br />" +
  "If the problem persists, please report your problem to <a href=\"mailto:support@sweatnow.com\">support@sweatnow.com</a> and mention this error message."){
    let message = null;
    message = !error.response ? defaultMessage : null;
    message = message ? message : defaultMessage;
    if( error?.response?.data?.code && [401, 419].includes(error.response.data.code)){
      message = 'Your login session expired. Please login again.';
      window.location = AppRoutes.login.path;
    }
    if( error?.response?.data?.errors){
      switch (error?.response?.data?.errors){
        case "badCredentials": message = 'Login failed. Please check your credentials and try again.'; break;
        default: message = error?.response?.data?.errors;
      }
    }
    if ('function'===typeof onErrorCallback){
      onErrorCallback(message);
    }
    HelperService.log(error);
  },
  getObjByKey: function(list=[], key=null, val=null){
    if (!list || !list.length || !key || !val){
      return null;
    }
    let foundItem = null;
    list.filter((item)=>{
      if (item.hasOwnProperty(key) && item[key] === val){
        foundItem = item;
      }
      return item;
    })
    return foundItem;
  },
  getObjByMaxValueKey: function(list=[], key=null){
    if (!list || !list.length || !key){
      return null;
    }
    if (list.length===1){
      return list.pop();
    }
    return list.reduce(function(prev, current) {
        if (!prev.hasOwnProperty(key) || !current.hasOwnProperty(key)){
          throw new Error(`${key} not in the object - cant get max value`);
        }
      return (prev.value > current.value) ? prev : current;
    });
  },
  addOrReplaceItemInList: function(list=[], item=null, keyAttribute='id'){
    if (!item || !item.hasOwnProperty(keyAttribute)){
      return list;
    }
    let oldRowFound = false;
    let newRows = list.map((old)=>{
      if (old[keyAttribute] === item[keyAttribute]){
        oldRowFound = true;
        return item;
      }
      return old;
    })
    if (!oldRowFound){
      newRows.push(item);
    }
    return newRows;
  },
  removeItemFromList: function(list=[], item=null, keyAttribute='id'){
    if (!item || !item.hasOwnProperty(keyAttribute)){
      return list;
    }
    return list.filter((old)=>{
      if (old[keyAttribute] === item[keyAttribute]){
        return false;
      }
      return true;
    })
  },
  dateSortFunction: function(a, b, sortKey) {
    const dayjs = require('dayjs');
    if (!a.hasOwnProperty(sortKey) || !b.hasOwnProperty(sortKey)){
      return 0;
    }
    return dayjs(a[sortKey]) - dayjs(b[sortKey]);
  },
  simpleSortFunction: function(a, b, sortKey) {
    if (!a.hasOwnProperty(sortKey) || !b.hasOwnProperty(sortKey)){
      return 0;
    }
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  },
  formatDate: function(date, format="D. M. YYYY"){
    if (!date){
      return '';
    }
    const dayjs = require('dayjs');
    let newDate = dayjs(date).format(format);
    if (newDate){
      return newDate;
    }
    return date;
  },
  formatDateTime: function(date, format="D. M. YYYY, HH:MM"){
    const dayjs = require('dayjs');
    let newDate = dayjs(date).format(format);
    if (newDate){
      return newDate;
    }
    return date;
  },
  objectPrettyPrint: function(obj = null, level = 0) {
    if (!obj || typeof obj !== 'object') {
      return '';
    }

    let htmlString = '';
    let keys = Object.keys(obj);

    if (!(keys && keys.length)) {
      return '';
    }

    htmlString = keys
        .map((k) => {
          if (obj && obj.hasOwnProperty(k) && obj[k] && typeof obj[k] === 'object') {
            return this.objectPrettyPrint(obj[k], level + 1);
          }
          return `<div class="ps-${level}"><span>${k}</span>: <strong>${JSON.stringify(obj[k])}</strong></div>`;
        })
        .join('');

    return `<div>${htmlString}</div>`;
  },
  getRandomColor: function(date, format="D. M. YYYY, HH:MM"){
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  },
  getInitials : function(user){
    let initials;
    let name = `${user.name} ${user.surname}`;
    const nameSplit = name.split(" ");
    const nameLength = nameSplit.length;
    if (nameLength > 1) {
      initials =
        nameSplit[0].substring(0, 1) +
        nameSplit[nameLength - 1].substring(0, 1);
    } else if (nameLength === 1) {
      initials = nameSplit[0].substring(0, 1);
    } else return;

    return initials.toUpperCase();
  },
  createImageFromInitials : function(size, name, color){
    if (name == null) return;

    const canvas=document.createElement('canvas')
    const context=canvas.getContext('2d')
    canvas.width=canvas.height=size

    context.fillStyle="#ffffff"
    context.fillRect(0,0,size,size)

    context.fillStyle=`${color}50`
    context.fillRect(0,0,size,size)

    context.fillStyle=color;
    context.textBaseline='middle'
    context.textAlign='center'
    context.font =`${size/2}px Outfit`
    context.fillText(name,(size/2),(size/2))

    return canvas.toDataURL()
  },
  scrollToElement: function (elementId){
    const el = document.getElementById(elementId);
    setTimeout(() => {
      if (el){
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  },
  generateKey: function(length = 6) {
    const chars = 'abcdefghijklmnopqrstuvwxyz1234567890';
    const rand = (min = 0, max = 1000) => Math.floor(Math.random() * (max - min) + min);
    const randchars = [];
    for (let i = 0; i < length; i++) {
      randchars.push(chars[rand(0, chars.length)]);
    }
    return randchars.join('');
  },
  sha512: function (str) {
    return crypto.subtle.digest("SHA-512", new TextEncoder("utf-8").encode(str)).then(buf => {
      return Array.prototype.map.call(new Uint8Array(buf), x=>(('00'+x.toString(16)).slice(-2))).join('');
    })
  },
  log: function (params){
    if (process.env.REACT_APP_DEBUG==='true'){
      console.log(params);
    }
  },
  respondToVisibility: function (element, callback) {
    const options = {
      root: document.documentElement,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { // Element comes into view
          callback(entry.intersectionRatio > 0);
        } else { // Element goes out of view
        }
      });
    }, options);

    observer.observe(element);
  },
  round: function (value, step) {
    step || (step = 1.0);
    var inv = 1.0 / step;
    return Math.round(value * inv) / inv;
  },
  getDistance: function (coord1, miles=true) {
    //this equation uses kilometers, so we need to convert to miles if we want them on the ui.
    if (!coord1?.lat || !coord1?.lon) {
      return '';
    }
    let f = getSearchFilter();
    if (!f?.lat || !f?.lon) {
      return '';
    }
    let coord2 = {lat: f.lat, lon: f.lon};

    const R = 6371; // Radius of the earth in km
    const latDistance = HelperService.deg2rad(coord2.lat - coord1.lat);
    const lonDistance = HelperService.deg2rad(coord2.lon - coord1.lon);
    const a =
        Math.sin(latDistance / 2) * Math.sin(latDistance / 2) +
        Math.cos(HelperService.deg2rad(coord1.lat)) * Math.cos(HelperService.deg2rad(coord2.lat)) *
        Math.sin(lonDistance / 2) * Math.sin(lonDistance / 2)
    ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const dist = (R * c).toFixed(1); // distance in km

    return miles ? (dist * 0.621371 ).toFixed(1) : dist;
  },
  deg2rad: function (deg) {
    return deg * (Math.PI / 180);
  },
  getNiceDateString: function (date, timezone, format='x') {
    const dayjs = HelperService.getDayjs();
    const d = dayjs(date, format).tz(timezone);
    let niceDate = null;
    if (!niceDate){
      niceDate = d.isToday() ? 'Today' : null;
    }
    if (!niceDate){
      niceDate = d.isTomorrow() ? 'Tomorrow' : null;
    }
    if (!niceDate){
      niceDate = d.format('dddd, D MMM');
    }
    return `${niceDate} · ${d.format('h:mm A')}`;
  },
  getFilterQueryString: function(filter){
    const dayjs = HelperService.getDayjs();
    let queryParts = [];
    for (let key in filter) {
      if (filter[key] !== null && filter[key] !== undefined) {
        if (key==='categories'){
          filter[key] = JSON.parse(filter[key]);
          filter[key] = filter[key] ? filter[key].join(',') : '';
        }
        if (key==='datetimeFrom'){
          filter[key] = filter[key] ? dayjs(filter[key]).set('hour', dayjs().hour()).set('minute', dayjs().minute()).unix()*1000 : '';
        }
        if (key==='datetimeTo'){
          filter[key] = filter[key] ? dayjs(filter[key]).add(1, 'day').unix()*1000 : '';
        }
        queryParts.push(encodeURIComponent(key) + '=' + encodeURIComponent(filter[key]));
      }
    }
    return queryParts.join('&');
  },
  getEventSpotsLeft: function(capacity){
    if (capacity?.nonMember===null || capacity.member===null){
      return null;
    }
    let nonMemberAvailable = Math.max(capacity.nonMember - capacity.nonMemberBooked, 0);
    let memberAvailable = Math.max(capacity.member - capacity.memberBooked, 0);
    return nonMemberAvailable + memberAvailable || 0;
  },
  getRadius: function(filter){
    //server uses km for storage. so we need to convert miles to km if were using them.
    if (!filter?.radius){
      return null;
    }
    let metric = filter?.filterMetric ? filter.filterMetric : 'mi';
    return metric==="mi" ? filter.radius * 1.60934 : filter.radius;
  },
  getEventOffsetString: function(date, timezone){
    const dayjs = HelperService.getDayjs();
    const time = dayjs(date, 'x').tz(timezone);

    const tzString = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'short'
    }).format(time);

    const offset = tzString.split(' ')[1];

    // Check if the offset is numbers only (no abbreviation).
    // If yes, then convert offset time to GMT notation.
    if (/^\d+$/.test(offset)) {
      const rawOffset = time.utcOffset() / 60;
      return `GMT${rawOffset >= 0 ? '+' : ''}${rawOffset}`;
    }

    return offset;
  }
}

export default HelperService;

export function helperService() {
  return {
    getRandomAnimation: HelperService.getRandomAnimation,
    handleFormErrors: HelperService.handleFormErrors,
    addOrReplaceItemInList: HelperService.addOrReplaceItemInList,
    formatDate: HelperService.formatDate,
    formatDateTime: HelperService.formatDateTime,
    objectPrettyPrint: HelperService.objectPrettyPrint,
    getRandomColor: HelperService.getRandomColor,
    getInitials : HelperService.getInitials ,
    createImageFromInitials : HelperService.createImageFromInitials ,
    generateKey : HelperService.generateKey ,
    dateSortFunction : HelperService.dateSortFunction,
    getObjByKey : HelperService.getObjByKey,
    getObjByMaxValueKey : HelperService.getObjByMaxValueKey,
    log : HelperService.log,
    respondToVisibility: HelperService.respondToVisibility,
    round: HelperService.round,
    getNiceDateString: HelperService.getNiceDateString,
    getDistance: HelperService.getDistance,
    getFilterQueryString: HelperService.getFilterQueryString(),
    getRadius: HelperService.getRadius()
  };
}
